<template>
  <span>
    <b-button
      @click.prevent="
        (e) => {
          e.target.blur();
          $bvModal.show('add-from-stock-modal-alfa');
        }
      "
      class="mr-1"
      >Agregar desde linea</b-button
    >
    <b-modal id="add-from-stock-modal-alfa" size="xl" @show="checkProcessOption">
      <template #modal-title>
        Stock de fruta: {{ $route.params.sag_filter.origin_name }} <i class="fa fa-angle-right"></i>
        {{ $route.params.sag_filter.variety_name }} <i class="fa fa-angle-right"></i>
        {{ $route.params.sag_filter.condition }}
      </template>
      <stock-list
        :column_display="columnsDisplay"
        :downloadeable="false"
        :columns="columns"
        :filterable="filterable"
        :headings="headings"
        :url="url"
        @select-row="rowClick($event)"
        @on-loading="loading = $event"
      />
    </b-modal>
  </span>
</template>

<script>
import StockList from "../../bagno_views/ServerFilterableTable";

export default {
  name: "AddFromStock",
  components: {
    StockList
  },
  data() {
    return {
      loading: false,
      sag_filter: true,
      columnsDisplay: {
        document: "not_desktop",
        product_name: "not_desktop",
        product_type_name: "min_desktop",
        approved: "min_desktop",
        string_specs: "not_desktop",
        daystay: "min_desktop",
        condition: "not_desktop",
        lot_number: "min_desktop",
        in_process: "not_desktop",
        involved_waybills: "not_desktop",
        last_inspection: "not_desktop",
        position: "not_desktop",
        variety_name: "not_desktop",
        origin_name: "not_desktop"
      },
      columns: [
        "pallet_number",
        "lot_number",
        "product_type_name",
        "container_name",
        "daystay",
        "string_specs",
        "variety_name",
        "origin_name",
        "condition",
        "in_process",
        "last_inspection",
        "approved",
        "quantity",
        "net_kilograms"
      ],
      filterable: [
        "client_customer_name",
        "pallet_number",
        "lot_number",
        "product_type_name",
        "product_name",
        "container_name",
        "position"
      ],
      headings: {
        pallet_number: "Pallet",
        lot_number: "Lote",
        container_name: "Formato/Recipiente",
        quantity: "Cantidad",
        product_type_name: "Tipo Producto",
        net_kilograms: "KN",
        daystay: "Días estadía",
        string_specs: "Especificaciones",
        last_inspection: "Inspección",
        in_process: "En proceso",
        variety_name: "Variedad",
        approved: "Estado",
        origin_name: "Huerto"
      }
    };
  },
  methods: {
    rowClick(evt) {
      this.$emit("row-click", evt);
    },
    checkProcessOption() {
      if (localStorage.getItem("ppo.sag_filter")) {
        this.sag_filter = localStorage.getItem("ppo.sag_filter") === "true";
      }
    }
  },
  computed: {
    url() {
      var url = `/api/v1/stock/`;
      if (this.sag_filter) {
        url += `?variety=${this.$route.params.sag_filter.variety_id}&allowed_product_types=${this.$route.params.process_type.id}&origin=${this.$route.params.sag_filter.origin_id}&condition=${this.$route.params.sag_filter.condition}`; // sending process_type id
      }
      return url;
    }
  }
};
</script>

<style scoped></style>
